'use es6';

// Reduce the given query string into an object of key-value query parameters
export function reduceQueryParams(queryString) {
  const queryParams = {};
  queryString.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), ($0, $1, $2, $3) => {
    const parsedParam = function () {
      try {
        // If param is an integer greater than the safe integer, do not parse
        if (/^\d+$/.test($3) && $3 > Number.MAX_SAFE_INTEGER) {
          return $3;
        }
        return JSON.parse($3);
      } catch (_) {
        return $3;
      }
    }();
    queryParams[$1] = parsedParam;
  });
  return queryParams;
}

// Extracts portalId and potentially appIds from url
export function extractIds(urlString) {
  const portalExpression = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)(?:.*\/(\d+)(?:\/|$))?/;
  const matchArr = portalExpression.exec(urlString);
  if (!matchArr) {
    console.error(`Warning: earlyRequester did not find any id matches in url \`'${urlString}'\`.`);
    return [];
  }
  return matchArr;
}